import config from "@/config";
import http from "@/utils/request";

const api = (path) => `${config.API_URL}${path}`;

export default {
	pushNotifications: {
		list: {
			url: api("/admin/live_by_message/list"),
			name: "消息管理列表",
			get(params) {
				return http.get(this.url, params);
			},
		},
		add: {
			url: api("/admin/live_by_message/add"),
			name: "新增消息",
			post(params) {
				return http.post(this.url, params);
			},
		},
	},
};
